<div class="bary-table-list table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr jhiSort [(predicate)]="pagination.predicate" [(ascending)]="pagination.reverse" (sortChange)="transition()">
        <th jhiSortBy="pickupZipCodeRule">
          <span jhiTranslate="baryApp.acceptance.pickupDepartment">Dep. Expédition </span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="pickupCountry">
          <span jhiTranslate="baryApp.acceptance.pickupCountry">Pays Expédition </span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="deliveryZipCodeRule">
          <span jhiTranslate="baryApp.acceptance.deliveryDepartment">Dep. Livraison </span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="deliveryCountry">
          <span jhiTranslate="baryApp.acceptance.deliveryCountry">Pays Livraison </span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="acceptanceDays">
          <span jhiTranslate="baryApp.acceptance.acceptanceDays">Délais (j) </span>
          <fa-icon icon="sort"></fa-icon>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let acceptance of acceptances; trackBy: trackId">
        <td>
          <span>{{ acceptance.pickupZipCodeData }}</span>
        </td>
        <td>
          <span>{{ acceptance.pickupCountry }}</span>
        </td>
        <td>
          <span>{{ acceptance.deliveryZipCodeData }}</span>
        </td>
        <td>
          <span>{{ acceptance.deliveryCountry }}</span>
        </td>
        <td>
          <span>{{ acceptance.acceptanceDays }}</span>
        </td>
      </tr>
      <tr [hidden]="acceptances && acceptances.length > 0">
        <td colspan="5" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="baryApp.acceptance.noData">No acceptances</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
